import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { UserService } from '../../services/user.service';

export interface IButton {
  name?: string;
  action: string;
  icon?: string;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  standalone: false
})
export class HeaderComponent {
  @Input() backgroundColor: string = '#f4f4f4';
  @Input() isLeftNeeded = true;
  @Input() src: string = '';
  @Input() name: string = '';
  @Input() buttons: IButton[] = [];

  @Output() clickLeft = new EventEmitter<any>();
  @Output() clickRight = new EventEmitter<string>();
  protected userService = inject(UserService);

  public clickButton(action: string) {
    this.clickRight.emit(action);
  }

  public clickMenu() {
    this.clickLeft.emit();
  }

}
